<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d557Ya/tc-custom/9781370057085.jpg?1693599626034" alt="This image is the cover for the book Tom's Turn, Seduced by Shark Shifters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tom's Turn, Seduced by Shark Shifters
      </h1>
      <p class="bookDescription body article font2">
        <p>Tom Whitmore's feelings for Logan White began the first day he saw him back in middle school, but somewhere in those wild college years, Tom's crush turned to love.<br/><br/>A year after college, all that was well and good, and Tom had even learned how to deal with being in love with his straight best friend, until stupid Logan White ran off and married a complete stranger ... an older, gorgeous, wealthy stranger who looks like a soap opera star, and just so happens to be able to turn into a shark.<br/><br/>No matter how idiotic the mistake, Tom has never given up on Logan, and he doesn't plan to start now. If he has to plot against this shark shifting man while battling Logan's own stubbornness, then so be it.<br/><br/>Because this time, it's Tom's turn.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rafe Jadison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0341162c